///////////////////////////////////////////////////////////////////////////////////////////////////
//
//  Namespaces
//
///////////////////////////////////////////////////////////////////////////////////////////////////
abcsetup.audit_logs = abcsetup.audit_logs || {};
abcsetup.audit_logs.details = abcsetup.audit_logs.details || {};



///////////////////////////////////////////////////////////////////////////////////////////////////
//
//  Methods
//
///////////////////////////////////////////////////////////////////////////////////////////////////
abcsetup.audit_logs.details = {
    init: function() {
        abcsetup.setTitle('Audit Logs');

        // Back button clicked
        $(document).on('click', '.btn-back', function(e) {
            e.preventDefault();
            window.history.back();
            return false;
        });
    },
}
